import {
  PrimaryDialog,
  WarningCustomIcon,
  StyledButton,
} from "react-common-ui-library";
import { useIntl } from "react-intl";
import { Box, Typography } from "@mui/material";
import {
  ACCOUNT_CREATION_FAILED_TITLE,
  ACCOUNT_CREATION_FAILED_OK_BTN,
  ACCOUNT_CREATION_FAILED_CONTENT,
  ACCOUNT_CREATION_FAILED_MODAL,
} from "../../../Constants/VerifyAccountConstants";
import {
  ACCOUNT_CREATION_ROUTE,
  BASE_ROUTE,
  CONFIRM_SITE_ACCESS_ROUTE,
  CONTAINED,
  ACCOUNT_CREATION_FLOW,
  H2,
  H3,
  PROVIDER_ACCOUNT_CREATION,
  CONTACT_INFO_ID,
  SPAN,
} from "../../../Constants/CommonConstants";
import PropTypes from "prop-types";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { clearProviderAccountCreationSlice } from "../../../Features/ProviderAccountCreationSlice";
import { clearAccountCreationSlice } from "../../../Features/AccountCreationSlice";

/**
 * @description The modal that is displayed when the account creation fails
 * @param {boolean} open Boolean flag to show the modal
 * @param {function} accountCreationFailedModalIsOpen Setter method to update the boolean flag
 * @param {string} contactInfo Displays the contact information based on the preferred verification method
 * @returns {ReactNode} Renders the modal to the user
 */
export const AccountCreationFailedModal = (props) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { open, setAccountCreationFailedModalIsOpen, contactInfo } = props;

  const onOkClickHandler = () => {
    setAccountCreationFailedModalIsOpen(false);
    if (
      sessionStorage.getItem(ACCOUNT_CREATION_FLOW) ===
      PROVIDER_ACCOUNT_CREATION
    ) {
      dispatch(clearProviderAccountCreationSlice());
      navigate(
        `${BASE_ROUTE}${ACCOUNT_CREATION_ROUTE}/${CONFIRM_SITE_ACCESS_ROUTE}`
      );
    } else {
      dispatch(clearAccountCreationSlice());
      navigate(`${BASE_ROUTE}${ACCOUNT_CREATION_ROUTE}`);
    }
  };

  return (
    <PrimaryDialog
      id={ACCOUNT_CREATION_FAILED_MODAL}
      title={intl.formatMessage({ id: ACCOUNT_CREATION_FAILED_TITLE })}
      titleIcon={<WarningCustomIcon />}
      open={open}
      actions={
        <StyledButton
          id={ACCOUNT_CREATION_FAILED_OK_BTN}
          variant={CONTAINED}
          onClick={onOkClickHandler}
        >
          {intl.formatMessage({ id: ACCOUNT_CREATION_FAILED_OK_BTN })}
        </StyledButton>
      }
    >
      <Typography
        id={ACCOUNT_CREATION_FAILED_CONTENT}
        component={H2}
        variant={H3}
      >
        {intl.formatMessage(
          {
            id: ACCOUNT_CREATION_FAILED_CONTENT,
          },
          {
            contact: (
              <Box component={SPAN} id={CONTACT_INFO_ID}>
                {contactInfo}
              </Box>
            ),
          }
        )}
      </Typography>
    </PrimaryDialog>
  );
};

AccountCreationFailedModal.propTypes = {
  /**
   * Displays modal when set to true
   */
  open: PropTypes.bool.isRequired,
  /**
   * Function to set modal open
   */
  setAccountCreationFailedModalIsOpen: PropTypes.func.isRequired,
  /**
   * Provides the contact information
   */
  contactInfo: PropTypes.string.isRequired,
};
